module.exports = __webpack_public_path__ + "img/American_Credit_Equipment_Loan_Process_Approved.b7be4d0.png";